import { useNavigate } from "react-router-dom";
import type { CalendarDay } from "../types";
import { daysInMonth, firstWeekday, toDateKey, todayKey } from "../utils/date";
import { formatCurrency } from "../utils/currency";

interface CalendarGridProps {
  year: number;
  month: number;
  days: CalendarDay[];
  limitCents: number;
}

const WEEKDAYS = ["日", "一", "二", "三", "四", "五", "六"];

export function CalendarGrid({ year, month, days, limitCents }: CalendarGridProps) {
  const navigate = useNavigate();
  const byDate = new Map(days.map((item) => [item.date, item]));
  const leading = firstWeekday(year, month);
  const count = daysInMonth(year, month);
  const today = todayKey();

  return (
    <div className="calendar-shell">
      <div className="weekday-row" aria-hidden="true">
        {WEEKDAYS.map((day) => <div key={day}>{day}</div>)}
      </div>
      <div className="calendar-grid" aria-label={`${year}年${month}月支出日历`}>
        {Array.from({ length: leading }).map((_, index) => (
          <div className="calendar-spacer" key={`spacer-${index}`} aria-hidden="true" />
        ))}
        {Array.from({ length: count }).map((_, index) => {
          const dayNumber = index + 1;
          const date = toDateKey(year, month, dayNumber);
          const value = byDate.get(date);
          const expense = value?.expense_cents ?? 0;
          const state = expense === 0 ? "empty" : expense > limitCents ? "over" : "within";
          return (
            <button
              key={date}
              className={`day-card ${state}${date === today ? " today" : ""}`}
              onClick={() => navigate(`/day/${date}`)}
              aria-label={`${month}月${dayNumber}日，支出${formatCurrency(expense)}`}
            >
              <span className="day-number">{date === today ? "今" : dayNumber}</span>
              <span className="day-amount">{formatCurrency(expense)}</span>
              {!!value?.income_cents && (
                <span className="day-income">收 {formatCurrency(value.income_cents)}</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
